import RulesMini from './RulesMini';
export default RulesMini;